import { BREAKPOINTS } from '../../utils/constants';

const getGalleryElement = (initFlag) => {
  const productGallery = document.querySelector('[data-product-gallery]');
  if (!productGallery || productGallery.dataset[initFlag]) return null;
  productGallery.dataset[initFlag] = 'true';
  return productGallery;
};

const initGalleryVideos = () => {
  const productGallery = getGalleryElement('videosInitialized');
  if (!productGallery) return;

  const videoSlides = productGallery.querySelectorAll('[data-slide-video]');
  if (!videoSlides.length) return;

  const visibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach(async (entry) => {
      const video = entry.target.querySelector('video');
      if (!video) return;

      if (entry.isIntersecting) {
        try {
          await video.play();
        } catch {
          // Autoplay blocked by the browser; safe to ignore.
        }
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.5 });

  videoSlides.forEach(slide => {
    const video = slide.querySelector('video');
    const videoBtn = slide.querySelector('[data-video-btn]');
    if (!video || !videoBtn) return;

    visibilityObserver.observe(slide);

    const setButtonState = (isPlaying) => {
      const label = isPlaying
        ? window.theme.strings.pauseVideo
        : window.theme.strings.playVideo;

      videoBtn.textContent = label;
      videoBtn.setAttribute('aria-label', label);
      videoBtn.setAttribute('aria-pressed', String(isPlaying));
    };

    video.addEventListener('play', () => setButtonState(true));
    video.addEventListener('pause', () => setButtonState(false));
  });

  productGallery.addEventListener('click', (event) => {
    const videoBtn = event.target.closest('[data-video-btn]');
    if (!videoBtn) return;

    const video = videoBtn.closest('[data-slide-video]')?.querySelector('video');
    if (!video) return;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });
};

const initLoadMore = () => {
  const productGallery = getGalleryElement('loadMoreInitialized');
  if (!productGallery) return;

  const grid = productGallery.querySelector('[data-media-grid]');
  const checkbox = productGallery.querySelector('[data-load-more-checkbox]');
  const label = productGallery.querySelector('[data-load-more-btn]');

  if (!grid || !checkbox) return;

  const ROWS_TO_SHOW = 2;

  function measure() {
    if (window.innerWidth < BREAKPOINTS.DESKTOP) return;

    const items = [...grid.querySelectorAll('[data-media-item]')];
    const lastVisible = items.findLast(item => {
      const row = parseInt(getComputedStyle(item).gridRowStart, 10);
      return row <= ROWS_TO_SHOW;
    });

    if (!lastVisible) return;

    const gridTop = grid.getBoundingClientRect().top;
    const clipHeight = lastVisible.getBoundingClientRect().bottom - gridTop;

    grid.style.setProperty('--clip-height', `${Math.round(clipHeight)}px`);
    grid.style.setProperty('--expanded-height', `${grid.scrollHeight}px`);
  }

  let rafId = null;
  const scheduleMeasure = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(measure);
  };

  const handleCheckboxChange = () => {
    measure();
    if (label) label.hidden = checkbox.checked;
  };

  if (label) label.hidden = checkbox.checked;

  if (label) {
    label.addEventListener('click', (event) => {
      event.preventDefault();
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  const resizeObserver = new ResizeObserver(scheduleMeasure);
  resizeObserver.observe(grid);
  checkbox.addEventListener('change', handleCheckboxChange);
  window.addEventListener('load', measure);
  measure();
};

export { initGalleryVideos, initLoadMore };
